import Vue from 'vue';
import Vuex from 'vuex';
import { loadModules, registerDynamicModules } from './loadModules.js';

import pathify from '../plugins/vuex-pathify';

const globalStoresContext = require.context('./global', false, /\.js$/);
const moduleStoresContext = require.context(
  '../modules/',
  true,
  /.*\/stores\/.*\.js$/
);

// REFACTOR: Use router guard to only add stores for a module if a route of that module is loaded, instead of loading all modules/stores here.
// Use above refactor to only load user store once userLayout is loaded.

const globalStores = loadModules(globalStoresContext);
const getModuleStores = loadModules.bind(this, moduleStoresContext);

// init store
// enable strict mode to ensure correct store usage during development
// https://v3.vuex.vuejs.org/guide/strict.html

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [pathify.plugin],
  modules: globalStores,
  strict: process.env.NODE_ENV === 'development',
});

registerDynamicModules(store, getModuleStores());

// TODO: add hot reloading support.
// https://v3.vuex.vuejs.org/guide/hot-reload.html#dynamic-module-hot-reloading

// if (module.hot) {
//   const reloadAllModules = () => {
//     store.hotUpdate({
//       modules: getGlobalStores(),
//     });

//     registerDynamicModules(store, getModuleStores(), true);
//   };

//   module.hot.accept(globalStoresContext.id, reloadAllModules);
//   module.hot.accept(moduleStoresContext.id, reloadAllModules);
// }

export default store;
